import Response from '../base/Response';
import Helpers from '../base/Helpers';
import RequestBehaviour from '../base/RequestBehaviour';
import ServiceBehaviour from '../base/ServiceBehaviour';
import CardTokenization from '../requests/CardTokenization';
import AuthTokenization from '../requests/AuthTokenization';
import PayloadResponse from '../responses/PayloadResponse';
import SuccessResponse from '../responses/SuccessResponse';
import Loading from '../libraries/PixelPayLoading';
import CardinalManager from '../libraries/CardinalManager';
import InvalidTransactionTypeException from '../exceptions/InvalidTransactionTypeException';

const BASE_CARD_PATH = 'api/v2/tokenization/card';

export default class Tokenization extends ServiceBehaviour {
	/**
	 * Vault credit/debit card and obtain a token card identifier (T-* format)
	 *
	 * @param card
	 * @return
	 * @throws InvalidCredentialsException
	 */
	async vaultCard(card: CardTokenization): Promise<Response> {
		Loading.show();
		const response = await this.post(BASE_CARD_PATH, card);
		Loading.hide();

		return response;
	}

	/**
	 * Authenticate card by token card identifier (T-* format)
	 *
	 * @param authentication
	 * @return
	 * @throws InvalidCredentialsException
	 * @throws InvalidTransactionTypeException
	 */
	async authCard(authentication: AuthTokenization): Promise<Response> {
		if (!Helpers.checkIsBrowser()) {
			throw new InvalidTransactionTypeException("This platform not support 3DS transactions");
		}

		try {
			Loading.show();

			const response = await this.post(BASE_CARD_PATH + '/auth', authentication);

			if (response instanceof SuccessResponse && response.data.authentication_identifier) {
				return response;
			}

			if (response instanceof PayloadResponse && response.data.transaction_type == 'songbird') {
				return await (new CardinalManager(this.settings, authentication)).init(
					response.data.payload,
					response.data.collection_url,
				);
			}

			CardinalManager.clearAllEvents();
			return response;
		} catch (err) {
			CardinalManager.clearAllEvents();
			throw err;
		} finally {
			Loading.hide();
		}
	}

	/**
	 * Update credit/debit card by token card identifier
	 *
	 * @param token
	 * @param card
	 * @return
	 * @throws InvalidCredentialsException
	 */
	async updateCard(token: string, card: CardTokenization): Promise<Response> {
		Loading.show();
		const response = await this.put(BASE_CARD_PATH + '/' + token, card);
		Loading.hide();

		return response;
	}

	/**
	 * Show credit/debit card metadata by token card identifier
	 *
	 * @param token
	 * @return
	 * @throws InvalidCredentialsException
	 */
	showCard(token: string): Promise<Response> {
		return this.get(BASE_CARD_PATH + '/' + token, new RequestBehaviour());
	}

	/**
	 * Show credit/debit card metadata by token card identifier
	 *
	 * @param token
	 * @return
	 * @throws InvalidCredentialsException
	 */
	showCards(tokens: string[]): Promise<Response> {
		let str = tokens.join(':')
		return this.get(BASE_CARD_PATH + '/' + str.split(' ').join(''), new RequestBehaviour());
	}

	/**
	 * Delete credit/debit card metadata by token card identifier
	 *
	 * @param token
	 * @return
	 * @throws InvalidCredentialsException
	 */
	async deleteCard(token: string): Promise<Response> {
		Loading.show();
		const response = await this.delete(BASE_CARD_PATH + '/' + token, new RequestBehaviour());
		Loading.hide();

		return response;
	}
}
